import type {IConfig} from 'unleash-proxy-client';

import FlagProvider from '@unleash/proxy-client-react';
import ErrorFallback from 'common/error-fallback/ErrorFallback';
import ReactDOM from 'react-dom/client';
import {ErrorBoundary} from 'react-error-boundary';
import {Provider} from 'react-redux';
import {store} from 'store';
import * as serviceWorker from 'utils/serviceWorker';

import App from './App';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

const unleashInitialConfig: IConfig = {
  url: import.meta.env.VITE_UNLEASH_URL,
  clientKey: import.meta.env.VITE_UNLEASH_CLIENT_KEY,
  refreshInterval: 60,
  appName: import.meta.env.VITE_UNLEASH_APPNAME
};

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <Provider store={store}>
      <FlagProvider config={unleashInitialConfig}>
        <App />
      </FlagProvider>
    </Provider>
  </ErrorBoundary>
);

serviceWorker.register();
